/* eslint-disable array-callback-return */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useFormik } from "formik";

// @material-ui/core components
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Divider from "@material-ui/core/Divider";
import Tab from "@material-ui/core/Tab";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import Create from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/lab components
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import { makeStyles } from "@material-ui/core/styles";

// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import TransferList from "components/List/TransferList";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import UtilsFncs from "utils/UtilsFncs";
import useStructureQueries from "hooks/useStructureQueries";
import TransferStoreList from "components/List/TransferStoreList";
import InputText from "components/_refactor/text/input";
import PasswordField from "components/_refactor/fields/password";

const useCustomStyles = makeStyles((theme) => ({
  isAdminStyle: {
    display: "none",
  },
  disableInput: {
    "& input.Mui-disabled": {
      backgroundColor: "rgb(240, 240, 240)",
    },
  },
}));

const filtraNaoVinculados = (items, vinculados, fieldKey) => {
  const naoVinculados = (items || []).filter(
    (field) =>
      !vinculados.some((vinculado) => vinculado[fieldKey] === field[fieldKey]),
  );
  return naoVinculados;
};

const checkNothingChanged = (
  selectedUser,
  perfisVinculados,
  canaisVinculados,
  marcasVinculados,
  initialPessoasVinculados,
  pessoasVinculados,
  userPassword,
) => {
  return (
    !selectedUser ||
    !(
      (perfisVinculados &&
        !UtilsFncs.ArrayEquals(selectedUser.UsuarioPerfis, perfisVinculados)) ||
      (canaisVinculados &&
        !UtilsFncs.ArrayEquals(selectedUser.UsuarioCanais, canaisVinculados)) ||
      (marcasVinculados &&
        !UtilsFncs.ArrayEquals(selectedUser.UsuarioMarcas, marcasVinculados)) ||
      (pessoasVinculados &&
        !UtilsFncs.ArrayEquals(initialPessoasVinculados, pessoasVinculados)) ||
      (userPassword && userPassword?.length !== 0)
    )
  );
};

export default function FormUserDialog({
  open,
  formType,
  onClose,
  selectedUser,
}) {
  const classes = useCustomStyles();
  const { getChannels, getBrands } = useStructureQueries();
  const [isAdmin, setIsAdmin] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [channels, setChannels] = useState([]);
  const [brands, setBrands] = useState([]);
  const [people, setPeople] = useState([]);

  const [preSelectedProfiles, setPreSelectedProfiles] = useState(
    selectedUser?.UsuarioPerfis || [],
  );
  const [preSelectedChannels, setPreSelectedChannels] = useState(
    selectedUser?.UsuarioCanais || [],
  );
  const [preSelectedBrands, setPreSelectedBrands] = useState(
    selectedUser?.UsuarioMarcas || [],
  );
  const [preSelectedPeople, setPreSelectedPeople] = useState(
    selectedUser?.UsuarioPessoas || [],
  );

  const [totalPage, setTotalPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRegistros, setTotalRegistros] = useState(null);
  const [filterStore, setFilterStore] = useState(null);
  const [isRepresentativeSelected, setIsRepresentativeSElected] =
    useState(false);
  const [perfisVinculados, setPerfisVinculados] = useState(
    selectedUser?.UsuarioPerfis || [],
  );
  const [canaisVinculados, setCanaisVinculados] = useState(
    selectedUser?.UsuarioCanais || [],
  );
  const [marcasVinculados, setMarcasVinculados] = useState(
    selectedUser?.UsuarioMarcas || [],
  );
  const [pessoasVinculados, setPessoasVinculados] = useState([]);
  const [initialPessoasVinculados, setInitialPessoasVinculados] =
    useState(null);
  const [tabVinculacao, setTabVinculacao] = useState("1");
  const [disablePasswordInput, setDisablePasswordInput] = useState(
    formType === "edit" && true,
  );
  const [userPassword, setUserPassword] = useState("");
  const [peopleLoading, setPeopleLoading] = useState(false);
  const [loadingNaoVinculados, setLoadingNaoVinculados] = useState(false);
  const snackbar = useSnackbar();
  const hasFetchedPeople = useRef(false);

  const filteredPeople = useMemo(() => {
    if (pessoasVinculados.length && people) {
      return people.filter(
        (item, index) =>
          pessoasVinculados.findIndex((p) => {
            console.log(p.Id, item.Id);
            return p.Id == item.Id;
          }) !== index,
      );
    }
    return people;
  }, [pessoasVinculados, people]);

  const submit = async (values) => {
    const { nome, login, backoffice, keycloak, inativo, codigo } = values;
    const updatedUser = selectedUser || {};
    setSubmitting(true);

    let objectFinal;
    const verifyPassword = { Senha: `${userPassword}` };

    const editObject = {
      IdUsuario: updatedUser.IdUsuario,
      Nome: nome,
      Login: login,
      CodigoERP: codigo ?? "",
      Backoffice: backoffice.toString(),
      Keycloak: keycloak.toString(),
      Perfis: perfisVinculados?.map((item) => item.IdPerfil).join(","),
      Pessoas: pessoasVinculados?.map((item) => item.Id).join(","),
      Marcas: marcasVinculados?.map((item) => item.IdMarca).join(","),
      Canais: canaisVinculados?.map((item) => item.IdCanal).join(","),
      Inativo: inativo,
    };

    if (userPassword && formType === "edit") {
      objectFinal = Object.assign({}, editObject, verifyPassword);
    } else if (!userPassword && formType === "edit") {
      objectFinal = editObject;
    } else if (userPassword && formType === "create") {
      objectFinal = Object.assign({}, editObject, verifyPassword);
      delete objectFinal.IdUsuario;
    } else if (!userPassword && formType === "create") {
      delete objectFinal.IdUsuario;
    }

    if (formType === "create") {
      if (pessoasVinculados?.length === 0) {
        delete objectFinal.Pessoas;
      }

      if (perfisVinculados?.length === 0) {
        delete objectFinal.Perfis;
      }

      if (marcasVinculados?.length === 0) {
        delete objectFinal.Marcas;
      }

      if (canaisVinculados?.length === 0) {
        delete objectFinal.Canais;
      }
    }

    if (formType === "edit") {
      return await Api.put("edit-user-full", "adminportal", objectFinal, true)
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Usuário atualizado com sucesso!`, {
              severity: "success",
            });
            handleClose({ ...updatedUser, ...res.Result });
          } else {
            snackbar.showMessage(
              `Ocorreu um erro ao atualizar o usuário. Verifique os parâmetros informados.`,
              {
                severity: "error",
              },
            );
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });        })
        .finally(() => setSubmitting(false));
    }

    if (formType === "create") {
      return await Api.post(
        "create-user-full",
        "adminportal",
        objectFinal,
        true,
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Usuário criado com sucesso!`, {
              severity: "success",
            });
            handleClose({ ...updatedUser, ...res.Result });
          } else {
            snackbar.showMessage(
              `Ocorreu um erro ao criar o usuário. Verifique os parâmetros informados.`,
              {
                severity: "error",
              },
            );
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });        })
        .finally(() => setSubmitting(false));
    }
  };

  const formik = useFormik({
    initialValues: {
      nome: selectedUser?.Nome || "",
      backoffice: selectedUser?.Backoffice || false,
      keycloak: selectedUser?.Keycloak ?? false,
      login: selectedUser?.Login || "",
      inativo: selectedUser?.Inativo || false,
      codigo: selectedUser?.CodigoErp || "",
    },
    onSubmit: submit,
  });

  const { values, handleChange, handleSubmit, dirty, resetForm } = formik;

  const handleClose = useCallback(
    (updatedUser) => {
      resetForm();
      onClose(updatedUser);
    },
    [onClose, resetForm],
  );

  const fetchProfiles = useCallback(() => {
    return Api.get(
      "list-profile",
      "adminportal",
      "?situacaoPerfil=ativos",
      true,
    )
      .then(({ Success, Result }) => {
        if (Success) {
          if (Result.length === 0) {
            setProfiles([]);
          } else if (!perfisVinculados) {
            setProfiles(Result);
            setPerfisVinculados([]);
          } else {
            const naoVinculados = filtraNaoVinculados(
              Result,
              perfisVinculados,
              "IdPerfil",
            );
            setProfiles(naoVinculados);
          }
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  }, [perfisVinculados, snackbar]);

  const fetchChannels = useCallback(async () => {
    try {
      const result = await getChannels();
      const Result = result?.data ?? [];
      if (Result.length === 0) {
        setChannels([]);
      } else if (!canaisVinculados) {
        setChannels(Result);
        setCanaisVinculados([]);
      } else {
        const naoVinculados = filtraNaoVinculados(
          Result,
          canaisVinculados,
          "IdCanal",
        );
        setChannels(naoVinculados);
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });    }
  }, [canaisVinculados, snackbar, getChannels]);

  const fetchBrands = useCallback(async () => {
    setPeople(null);
    try {
      const result = await getBrands();
      const Result = result?.data ?? [];
      const newListBrands = [];
      let newObject = {};

      if (Result.length === 0) {
        setBrands([]);
      } else if (!marcasVinculados) {
        Result.forEach((brand) => {
          if (brand?.IdMarca !== 0) {
            newObject = {
              IdMarca: brand?.IdMarca,
              Nome: brand?.Nome,
              Sigla: brand?.Sigla,
              UrlSite: brand?.UrlSite,
            };
            newListBrands.push(newObject);
          }
        });
        setBrands(newListBrands);
        setMarcasVinculados([]);
      } else {
        Result.forEach((brand) => {
          if (brand?.IdMarca !== 0) {
            newObject = {
              IdMarca: brand?.IdMarca,
              Nome: brand?.Nome,
              Sigla: brand?.Sigla,
              UrlSite: brand?.UrlSite,
            };
            newListBrands.push(newObject);
          }
        });
        const naoVinculados = filtraNaoVinculados(
          newListBrands,
          marcasVinculados,
          "IdMarca",
        );
        setBrands(naoVinculados);
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });    }
  }, [marcasVinculados, snackbar, getBrands]);

  const fetchPeople = useCallback(() => {
    setLoadingNaoVinculados(true);
    return Api.get(
      "store-user",
      "commercialstructure",
      `?page=${currentPage}&filtro=${
        filterStore ? filterStore : ""
      }&pageSize=100`,
      true,
    )
      .then(({ Success, Result }) => {
        if (Success) {
          if (Result.ListLojas.length === 0) {
            setPeople([]);
            setTotalPage("0");
            setTotalRegistros("0");
          } else {
            const naoVinculados = filtraNaoVinculados(
              Result.ListLojas,
              pessoasVinculados,
              "Id",
            );

            const peoplesList = naoVinculados?.map((person) => {
              const verifyCpfCnpj =
                person?.CNPJ?.length === 14
                  ? person?.CNPJ?.replace(
                      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      "$1.$2.$3/$4-$5",
                    )
                  : person?.CNPJ?.replace(
                      /(\d{3})(\d{3})(\d{3})(\d{2})/g,
                      "$1.$2.$3-$4",
                    );

              return {
                Id: person?.Id,
                Nome: person?.Nome,
                Cnpj: verifyCpfCnpj,
                Apelido: person?.Apelido,
              };
            });

            setPeople(peoplesList);
            setTotalRegistros(Result.TotalRegistros - pessoasVinculados.length);
            setTotalPage(
              Math.ceil(Result.TotalRegistros - pessoasVinculados.length) / 100,
            );
          }
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => {
        hasFetchedPeople.current = true;
        setLoadingNaoVinculados(false);
      });
  }, [pessoasVinculados, snackbar, filterStore, currentPage]);

  const fetchPessoasVinculados = useCallback(
    (page = 0, array = []) => {
      return Api.get(
        "store-user",
        "commercialstructure",
        `?page=${page}&pageSize=10000&idUsuario=${selectedUser.IdUsuario}`,
        true,
      )
        .then(({ Success, Result }) => {
          if (Success) {
            setPeopleLoading(false);
            const peoplesList = Result?.ListLojas?.map((person) => {
              const verifyCpfCnpj =
                person?.CnpjCpfPessoa?.length === 14
                  ? person?.CnpjCpfPessoa?.replace(
                      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      "$1.$2.$3/$4-$5",
                    )
                  : person?.CnpjCpfPessoa?.replace(
                      /(\d{3})(\d{3})(\d{3})(\d{2})/g,
                      "$1.$2.$3-$4",
                    );

              return {
                Id: person.Id,
                Nome: person.Nome,
                Cnpj: verifyCpfCnpj,
                Apelido: person?.Apelido,
              };
            });

            if (page === Result.TotalDePaginas) {
              setInitialPessoasVinculados([...array, ...peoplesList]);
              setPessoasVinculados([...array, ...peoplesList]);
            } else {
              fetchPessoasVinculados(page + 1, [...array, ...peoplesList]);
            }
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });        });
    },
    [selectedUser?.IdUsuario, snackbar],
  );

  const handleTabChange = (e, newTab) => {
    if (newTab !== tabVinculacao) {
      let naoVinculados = [];

      switch (newTab) {
        case "1":
          naoVinculados = filtraNaoVinculados(
            profiles,
            perfisVinculados,
            "IdPerfil",
          );

          setProfiles(naoVinculados);
          break;
        case "2":
          naoVinculados = filtraNaoVinculados(
            channels,
            canaisVinculados,
            "IdCanal",
          );

          setChannels(naoVinculados);
          break;
        case "3":
          naoVinculados = filtraNaoVinculados(
            brands,
            marcasVinculados,
            "IdMarca",
          );

          setBrands(naoVinculados);
          break;
        case "4":
          break;
        default:
          break;
      }

      setTabVinculacao(newTab);
    }
  };

  const handleVerifyProfile = () => {
    const userLoggedProfile = JSON.parse(
      localStorage.getItem("userDetail"),
    ).UsuarioPerfis;
    const userLoggedProfileVision = JSON.parse(
      localStorage.getItem("userDetailVision"),
    )?.UsuarioPerfis;
    const userProfile = userLoggedProfileVision
      ? userLoggedProfileVision
      : userLoggedProfile;

    userProfile.map((userProfile) => {
      if (userProfile.NomePerfil === "ADM") {
        return setIsAdmin(true);
      }
    });
  };

  const handleVerifySelectedProfiles = () => {
    setIsRepresentativeSElected(false);

    perfisVinculados?.map((selected) => {
      if (
        selected?.Nome === "REPRESENTANTE" ||
        selected?.Nome === "REPRESENTANTE_ADM"
      ) {
        setIsRepresentativeSElected(true);
      }
    });
  };

  useEffect(() => {
    handleVerifyProfile();
  }, []);

  useEffect(() => {
    if (formType === "edit") {
      setPeopleLoading(true);
      Promise.all([
        !profiles || profiles.length === 0 ? fetchProfiles() : null,
        !channels || channels.length === 0 ? fetchChannels() : null,
        !brands || brands.length === 0 ? fetchBrands() : null,
        fetchPessoasVinculados(),
      ]).then(() => {
        setPeopleLoading(false);
      });
    } else {
      Promise.all([
        !profiles || profiles.length === 0 ? fetchProfiles() : null,
        !channels || channels.length === 0 ? fetchChannels() : null,
        !brands || brands.length === 0 ? fetchBrands() : null,
        !people || people.length === 0 ? fetchPeople() : null,
      ]).then(() => {
        // setPeopleLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pessoasVinculados && !hasFetchedPeople.current) {
      if (!people && formType === "edit") {
        fetchPeople();
      }
    }
  }, [pessoasVinculados]);

  useEffect(() => {
    handleVerifySelectedProfiles();
  }, [perfisVinculados]);

  useEffect(() => {
    console.log("current page do effect: ", currentPage);
    if (hasFetchedPeople.current) {
      fetchPeople();
    }
  }, [currentPage, filterStore]);

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth={"xl"}>
        <PerfectScrollbar>
          <DialogTitle>
            <Typography id="alert-dialog-title" variant="h3" component="h3">
              {`${formType === "edit" ? "Editar" : "Criar"} Usuário`}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4}>
                <FormGroup>
                  <InputText
                    label="Nome"
                    required
                    disabled={submitting}
                    value={values.nome}
                    onChange={handleChange}
                    props={{
                      name: "nome",
                      onInput: (e) => {
                        e.target.value = e.target.value
                          .toString()
                          .slice(0, 200);
                      },
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormGroup>
                  <InputText
                    label="Login"
                    required
                    disabled={submitting}
                    value={values.login}
                    onChange={handleChange}
                    placeholder="voce@dominio.com"
                    type="email"
                    props={{
                      name: "login",
                      onInput: (e) => {
                        e.target.value = e.target.value
                          .toString()
                          .slice(0, 200);
                      },
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormGroup>
                  <PasswordField
                    label="Senha"
                    value={userPassword}
                    disabled={disablePasswordInput}
                    onChange={(e) => setUserPassword(e.target.value)}
                    required
                  />

                  {formType === "edit" && (
                    <Tooltip title="Editar">
                      <IconButton
                        aria-label="edit"
                        onClick={() => {
                          setDisablePasswordInput(!disablePasswordInput);
                          setUserPassword("");
                        }}
                      >
                        <Box
                          component={Create}
                          width="1.25rem!important"
                          height="1.25rem!important"
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                </FormGroup>
              </Grid>

              {isRepresentativeSelected && (
                <Grid item xs={6}>
                  <FormGroup>
                    <InputText
                      label="Código ERP"
                      disabled={submitting}
                      value={values.codigo}
                      onChange={handleChange}
                      props={{
                        name: "codigo",
                        onInput: (e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 10);
                        },
                      }}
                    />
                  </FormGroup>
                </Grid>
              )}

              <Grid
                item
                xs={6}
                style={{ display: "flex", alignItems: "center" }}
              >
                <FormGroup row style={{ marginBottom: 0 }}>
                  {isAdmin && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.backoffice}
                          onChange={handleChange}
                          name="backoffice"
                          color="primary"
                          disabled={submitting}
                        />
                      }
                      label={<FormLabel>Backoffice</FormLabel>}
                    />
                  )}
                  {isAdmin && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.keycloak}
                          onChange={handleChange}
                          name="keycloak"
                          color="primary"
                          disabled={submitting}
                        />
                      }
                      label={<FormLabel>Keycloak</FormLabel>}
                    />
                  )}
                  {formType === "edit" && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.inativo}
                          onChange={handleChange}
                          name="inativo"
                          color="primary"
                          disabled={submitting}
                        />
                      }
                      label={<FormLabel>Inativo</FormLabel>}
                    />
                  )}
                </FormGroup>
              </Grid>
              <>
                <Grid item xs={12}>
                  <Divider style={{ width: "100%", marginBottom: "0.5rem" }} />
                  <Typography variant="h4">Vínculos do Usuário</Typography>
                  <TabContext value={tabVinculacao}>
                    <Box style={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleTabChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab
                          label={formType === "create" ? "Perfis *" : "Perfis"}
                          value="1"
                          icon={
                            !profiles || !perfisVinculados ? (
                              <HourglassEmptyIcon />
                            ) : null
                          }
                          disabled={
                            submitting || !profiles || !perfisVinculados
                          }
                        />
                        <Tab
                          // className={!isAdmin && classes.isAdminStyle}
                          label="Canais"
                          value="2"
                          icon={
                            !channels || !canaisVinculados ? (
                              <HourglassEmptyIcon />
                            ) : null
                          }
                          disabled={
                            submitting || !channels || !canaisVinculados
                          }
                        />
                        <Tab
                          // className={!isAdmin && classes.isAdminStyle}
                          label="Marcas"
                          value="3"
                          icon={
                            !brands || !marcasVinculados ? (
                              <HourglassEmptyIcon />
                            ) : null
                          }
                          disabled={submitting || !brands || !marcasVinculados}
                        />
                        <Tab
                          label={formType === "create" ? "Lojas *" : "Lojas"}
                          value="4"
                          icon={!people ? <HourglassEmptyIcon /> : null}
                          disabled={submitting || !people || peopleLoading}
                        />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <TransferList
                        loading={!profiles}
                        initialLeft={profiles}
                        initialRight={perfisVinculados}
                        leftLabel="Perfis disponíveis"
                        rightLabel="Perfis vinculados"
                        onRightChange={(value) =>
                          value &&
                          !UtilsFncs.ArrayEquals(value, perfisVinculados) &&
                          setPerfisVinculados(value)
                        }
                        itemLabelKey="Nome"
                        itemIdKey="IdPerfil"
                        checked={preSelectedProfiles}
                        setChecked={setPreSelectedProfiles}
                      />
                    </TabPanel>
                    <TabPanel value="2">
                      <TransferList
                        loading={!channels}
                        initialLeft={channels}
                        initialRight={canaisVinculados}
                        leftLabel="Canais disponíveis"
                        rightLabel="Canais vinculados"
                        onRightChange={(value) =>
                          value &&
                          !UtilsFncs.ArrayEquals(value, canaisVinculados) &&
                          setCanaisVinculados(value)
                        }
                        itemLabelKey="Nome"
                        itemIdKey="IdCanal"
                        checked={preSelectedChannels}
                        setChecked={setPreSelectedChannels}
                      />
                    </TabPanel>
                    <TabPanel value="3">
                      <TransferList
                        loading={!brands}
                        initialLeft={brands}
                        initialRight={marcasVinculados}
                        leftLabel="Marcas disponíveis"
                        rightLabel="Marcas vinculadas"
                        onRightChange={(value) =>
                          value &&
                          !UtilsFncs.ArrayEquals(value, marcasVinculados) &&
                          setMarcasVinculados(value)
                        }
                        itemLabelKey="Nome"
                        itemIdKey="IdMarca"
                        checked={preSelectedBrands}
                        setChecked={setPreSelectedBrands}
                      />
                    </TabPanel>
                    <TabPanel value="4">
                      <TransferStoreList
                        loadingLeft={loadingNaoVinculados}
                        initialLeft={filteredPeople}
                        initialRight={pessoasVinculados}
                        leftLabel="Lojas disponíveis"
                        rightLabel="Lojas vinculadas"
                        onRightChange={(value) => {
                          value &&
                            !UtilsFncs.ArrayEquals(value, pessoasVinculados) &&
                            setPessoasVinculados(value);
                        }}
                        itemTooltipKey="Apelido"
                        itemLabelKey="Nome"
                        itemExtraLabelKey="Cnpj"
                        itemIdKey="Id"
                        setFilterStore={setFilterStore}
                        totalRegistros={
                          totalRegistros - pessoasVinculados?.length
                        }
                        currentPage={Number(currentPage)}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPage}
                        checked={preSelectedPeople}
                        setChecked={setPreSelectedPeople}
                      />
                    </TabPanel>
                  </TabContext>
                </Grid>
              </>
            </Grid>
            {submitting && (
              <div style={{ marginTop: "1rem" }}>
                <span>{`${
                  formType === "create" ? "Criando" : "Atualizando"
                } usuário...`}</span>
                <LinearProgress />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button component={Box} onClick={handleClose} disabled={submitting}>
              Cancelar
            </Button>
            <Button
              color="default"
              variant="contained"
              type="submit"
              disabled={
                // loadingVinculos ||
                submitting ||
                (!disablePasswordInput &&
                  MaskAndValid.isNullOrEmpty(userPassword)) ||
                (checkNothingChanged(
                  selectedUser,
                  perfisVinculados,
                  canaisVinculados,
                  marcasVinculados,
                  initialPessoasVinculados,
                  pessoasVinculados,
                  userPassword,
                ) &&
                  formType === "edit" &&
                  !dirty) ||
                MaskAndValid.isNullOrEmpty(values.nome) ||
                MaskAndValid.isNullOrEmpty(values.login) ||
                !MaskAndValid.validateEmail(values.login) ||
                (formType === "create" && perfisVinculados?.length === 0)
              }
              onClick={handleSubmit}
            >
              {formType === "edit" ? "Atualizar" : "Criar"}
            </Button>
          </DialogActions>
        </PerfectScrollbar>
      </Dialog>
    </>
  );
}
